<div class="md:flex hidden flex-none w-44">
	{{ controller.i18n + '.date.text' | translate }}
</div>
<div class="md:flex hidden flex-1">
	{{ controller.i18n + '.description.text' | translate }}
</div>
<div class="md:flex hidden flex-none w-28">
	{{ controller.i18n + '.status.text' | translate }}
</div>
<div class="md:flex hidden flex-none w-10"></div>
